import { createBrowserHistory } from "history";

let browseHistory;

if (typeof document !== "undefined") {
  browseHistory = createBrowserHistory({ forceRefresh: true });
}

export const history = browseHistory;
